import { Box, CircularProgress, TableCell, TableRow } from "@mui/material";

export const LoadingList = () => {
  return (
    <TableRow>
      <TableCell colSpan={999} sx={{ textAlign: "center", height: "460px" }}>
        <Box display={"flex"} justifyContent={"center"} p={3}>
          <CircularProgress />
        </Box>
      </TableCell>
    </TableRow>
  );
};
